var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"second_box"},_vm._l((_vm.tabArr),function(item,index){return _c('a',{key:index,class:_vm.tabArrindex == index ? 'active' : '',attrs:{"href":"#"},on:{"click":function($event){return _vm.sendValue(index)}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }